import React from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

import { foodGroupsQuery } from '@/api'
import { CompactTable } from '@/components/Table'
import { PageEditHeader } from '@/components/PageEditHeader'

export const Route = createFileRoute('/foodgroups/')({
  loader: ({ context: { queryClient } }) => queryClient.ensureQueryData(foodGroupsQuery),
  component: FoodGroupsComponent,
})

function FoodGroupsComponent() {
  const foodGroups = Route.useLoaderData()
  const { t } = useTranslation()

  return (
    <>
      <PageEditHeader title={t('foodGroups.title')}></PageEditHeader>
      <CompactTable
        aria-label="Food groups"
        columns={[
          {
            key: 'name',
            label: 'Name',
          },
        ]}
        rows={foodGroups}
        onLinkAction={(row) => {
          return `/foodgroups/${row.idGroup}`
        }}
      />
    </>
  )
}
